<script setup lang="ts">
import { LockKeyhole } from '@lucide/vue'
import { fallbackLogoSource } from '~~/shared/utils/branding'

const props = defineProps<{
  app: {
    name: string
    locale: string
    branding: { logo: string }
    appearance: { accent: string; theme: 'light' | 'dark' | 'auto' }
  }
  wide?: boolean
}>()
const logo = ref(props.app.branding.logo)
const { selectedTheme, cycleTheme } = useAppearance(
  computed(() => props.app.appearance.theme),
  computed(() => props.app.appearance.accent),
)
function fallback() {
  logo.value = fallbackLogoSource(logo.value)
}
</script>

<template>
  <main class="auth-shell">
    <div
      class="auth-backdrop"
      aria-hidden="true"
    >
      <span /><span /><span />
    </div>
    <header class="auth-topbar">
      <NuxtLink
        class="auth-brand"
        to="/"
        :aria-label="app.name"
        ><span class="auth-brand-mark"
          ><img
            :src="logo"
            alt=""
            @error="fallback" /></span
        ><span>{{ app.name }}</span></NuxtLink
      >
      <UiThemeControl
        :theme="selectedTheme"
        @cycle="cycleTheme"
      />
    </header>
    <section
      class="auth-card"
      :class="{ 'auth-card-wide': wide }"
    >
      <slot />
      <footer class="auth-card-footer">
        <LockKeyhole
          :size="14"
          aria-hidden="true"
        /><span>Connexion chiffrée · Données conservées localement</span>
      </footer>
    </section>
  </main>
</template>
